import { Pipe, PipeTransform } from '@angular/core';

export const MATERIAL_DISPLAY_MAPPING: Record<string, string> = {
  'Construction & Demolition (C&D)': 'Construction & Demolition (C&D)',
  'Household trash': 'Household Trash',
  'Roofing material': 'Roofing Material',
  'Cement/concrete': 'Cement/Concrete',
  Wood: 'Wood',
  Metal: 'Metal',
  'Recyclable material': 'Recyclable Material',
  'Zero-Sort': 'Single stream recycling',
  'Recycling / Zero-Sort Facility': 'Recycling / Single stream recycling facility',
  Other: 'Other',
};

@Pipe({
  name: 'materialDisplay',
  standalone: true,
})
export class MaterialDisplayPipe implements PipeTransform {
  transform(value: string | string[] | null | undefined): string {
    if (!value) {
      return '';
    }

    if (Array.isArray(value)) {
      return value.map((v) => MATERIAL_DISPLAY_MAPPING[v] || v).join(', ');
    }

    return MATERIAL_DISPLAY_MAPPING[value] || value;
  }
}
